import React from 'react';
import { type MessageDescriptor, useIntl } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Box from '@atlaskit/primitives/box';
// oxlint-disable-next-line @atlaskit/design-system/no-emotion-primitives
import { xcss } from '@atlaskit/primitives/xcss';
import CrossIcon from '@atlaskit/icon/core/cross';
import IconButton from '@atlaskit/button/icon/button';

const dismissIconStyles = xcss({
	position: 'absolute',
	top: 'space.0',
	right: 'space.0',
	cursor: 'pointer',
});

export const HTV2DismissButton = ({
	onDismiss,
	label,
}: {
	onDismiss?: () => void;
	label: MessageDescriptor;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={dismissIconStyles}>
			<IconButton
				isTooltipDisabled={false}
				onClick={onDismiss}
				label={formatMessage(label)}
				appearance="subtle"
				icon={(iconProps) => <CrossIcon {...iconProps} />}
			/>
		</Box>
	);
};
